




















































































import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import DeleteModal from "@/components/modal/DeleteModal.vue";
import NoteBox from "@/basics/boxes/NoteBox.vue";
import DateTimePicker from "@/basics/inputs/DateTimePicker.vue";
import NoData from "@/basics/boxes/NoData.vue";
import LabelInputDate from "@/components/inputs/LabelInputDate.vue";
import LabelInputText from "@/components/inputs/LabelInputText.vue";
import SimpleTable from "@/basics/table/SimpleTable.vue";

import formatDate from "@/lib/formatDate";

import { ROOM_ONE, RoomVariables, RoomData } from "@/graphql/query/room/one";
import {
  TELEPHONE_KEY_ALL,
  TelephoneKeyVariables,
  TelephoneKeyData,
  TelephoneKeyAllData
} from "@/graphql/query/telephoneKey/all";

import { createFamilyKey } from "@/graphql/mutation/createFamilyKey";
import { createTelKey } from "@/graphql/mutation/createTelKey";
import { updateTelephoneKey } from "@/graphql/mutation/deleteTelKey";

@Component({
  components: {
    CButton,
    DeleteModal,
    NoteBox,
    DateTimePicker,
    NoData,
    LabelInputDate,
    LabelInputText,
    SimpleTable
  },
  filters: {
    formatDateFilter(value: any): string | null {
      if (!value) {
        return null;
      }
      return formatDate(new Date(value));
    }
  },
  apollo: {
    room: {
      query: ROOM_ONE,
      variables(): RoomVariables {
        return { roomId: this.$apollo.vm.$route.params.roomId };
      }
    },
    telephoneKeys: {
      query: TELEPHONE_KEY_ALL,
      variables(): TelephoneKeyVariables {
        return { roomId: this.$apollo.vm.$route.params.roomId };
      },
      update(data: TelephoneKeyAllData): TelephoneKeyData[] {
        return data.telephoneKeyFeed.telephoneKeys.map(a => ({
          ...a,
          start: formatDate(new Date(a.start)),
          end: formatDate(new Date(a.end)),
          createdAt: formatDate(new Date(a.createdAt))
        }));
      }
    }
  }
})
export default class KeyList extends Vue {
  room: RoomData | null = null;
  telephoneKeys!: TelephoneKeyData[];
  dates = { start: new Date(), end: new Date() };
  name: string = "";
  telKeyDeleteModal: { [key: string]: boolean } = {};

  // idを指定してモーダル操作
  async showModal(id: string) {
    this.telKeyDeleteModal[id] = true;
    this.$forceUpdate();
  }

  async dismissModal(id: string) {
    this.telKeyDeleteModal[id] = false;
    this.$forceUpdate();
  }

  async telKey() {
    // バリデーション
    const name = this.name.trim();
    if (!name) {
      alert("名前を入力してください");
      return;
    }
    const { start, end } = this.dates;
    if (end <= start || end < new Date()) {
      alert("有効期限を確認してください");
      return;
    }
    const tab = window.open("", "_blank")!;
    try {
      const result = await createTelKey(this.$apollo, {
        name,
        roomId: this.$route.params.roomId,
        start,
        end
      });

      if (!result.data) throw new Error("データが取得できませんでした");

      const { href } = this.$router.resolve({
        name: "print-telkey",
        query: {
          tel: result.data.createTelKey.tel,
          callId: result.data.createTelKey.code,
          building: this.room!.building.name,
          start: this.dates.start.getTime().toString(),
          end: this.dates.end.getTime().toString(),
          room: this.room!.name
        }
      });
      tab!.location.href = href;
      // クエリ再取得
      await this.$apollo.queries.telephoneKeys.refresh();
    } catch (e) {
      tab.close();
      alert(e.message);
    }
  }

  async deleteTelKey(id: string) {
    try {
      await updateTelephoneKey(this.$apollo, {
        room_id: this.$apollo.vm.$route.params.roomId,
        id: id
      });
      this.telKeyDeleteModal[id] = false;
      // クエリ再取得
      await this.$apollo.queries.telephoneKeys.refresh();
    } catch (e) {
      // TODO: 複数エラーの場合の対処
      alert(e.graphQLErrors[0].message);
      this.telKeyDeleteModal[id] = false;
    }
  }

  async familyKey() {
    const tab = window.open("", "_blank")!;
    try {
      const result = await createFamilyKey(this.$apollo, {
        roomId: this.$route.params.roomId
      });

      if (!result.data) throw new Error("データが取得できませんでした");

      const { href } = this.$router.resolve({
        name: "print-invitation",
        query: {
          url: result.data.createFamilyKey,
          building: this.room!.building.name,
          start: this.dates.start.getTime().toString(),
          room: this.room!.name
        }
      });
      tab.location.href = href;
    } catch (e) {
      tab.close();
      alert(e.message);
    }
  }

  get hasFamilyKeys(): boolean {
    if (this.room) {
      return !!(this.room.familyKeys && this.room.familyKeys.length);
    } else {
      return false;
    }
  }
}
